import { FC, useCallback } from 'react'
import { useStoreSelector, useStoreDispatch } from 'helpers/reactReduxHelpers'
import FloatingPaneNotification from 'components/features/pfm/FloatingPaneNotification/FloatingPaneNotification'
import { resetPostFutureLayerErrorActionCreator } from 'components/features/future/actions'


type FutureAssumptionsOverlayProps = {}
export const FutureAssumptionsOverlay: FC<FutureAssumptionsOverlayProps> = () => {

  const hasError = useStoreSelector((state) => {
    const { isLoading, errorCode } = state.data.future.assumptions
    return !!errorCode && errorCode !== 400 && !isLoading
  })

  const dispatch = useStoreDispatch()
  const handleClose = useCallback(() => {
    dispatch(resetPostFutureLayerErrorActionCreator())
  }, [dispatch])

  if (!hasError) {
    return null
  }
  return (
    <FloatingPaneNotification onDismiss={ handleClose }>
      Can't perform action
    </FloatingPaneNotification>
  )
}
